import { UsersDetailsTicketsTab } from "./UsersDetailsTicketsTab";

export default UsersDetailsTicketsTab;
